<template>
  <div>
    <el-dialog
      @close="close"
      @open="open"
      :title="title"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-form size="mini" :model="formData" ref="formData" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品图标" prop="img">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :http-request="uploadIcon"
                :accept="profileConfig.accept"
              >
                <img
                  v-if="formData.img"
                  :src="formData.img"
                  class="avatar"
                  alt=""
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <!-- <upload
                :value="formData.img"
                url="/financial-admin/file/upload"
                @change="handleFormChange('imageUrl', $event)"
                :data="{
                  isKeepName: true,
                }"
              ></upload> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动币种" prop="coinType" required>
              <el-select
                v-model="formData.coinType"
                filterable
                placeholder="请选择活动币种"
                class="width-200"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in coinList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="总共发放收益" prop="totalIncome" required>
              <el-input
                v-model="formData.totalIncome"
                class="width-200"
              ></el-input>
              {{ formData.coinType }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金额精度" prop="scale" required>
              <el-input v-model="formData.scale" class="width-200"></el-input>
              {{ formData.coin }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="dtos" label="质押币种" required>
              <el-select
                style="width: 100%"
                v-model="formData.dtos"
                filterable
                multiple
                :multiple-limit="10"
                placeholder="请选择质押币种"
                @change="defiCoinChange"
              >
                <el-option
                  v-for="item in coinList || []"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-for="item in formData.defiCoins || []"
          :key="item.defiCoinType"
          style="padding-bottom: 20px"
        >
          <el-col :span="3" class="flex row-center align-center">
            <span class="defi-require">图标</span>&nbsp;&nbsp;
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :http-request="(e) => uploadIcon(e, item.defiCoinType)"
              :accept="profileConfig.accept"
            >
              <img
                v-if="item.defiImg"
                :src="item.defiImg"
                class="avatar"
                alt=""
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
          <el-col :span="5" class="flex row-center align-center">
            <el-input
              v-model="item.rate"
              class="width-150"
              placeholder="比例"
              :disabled="isEdit && formData.status !== 0"
            >
              <template v-slot:prepend>{{ item.defiCoinType }}</template>
              <template v-slot:suffix>
                <div style="height: 100%; display: flex; align-items: center">
                  %
                </div>
              </template>
            </el-input>
          </el-col>
          <el-col
            :span="4"
            style="display: flex; align-items: center; justify-content: center"
          >
            <span v-if="formData.totalIncome && item.rate">{{
              numDiv(
                parseFloat(
                  numMul(
                    parseFloat(formData.totalIncome),
                    parseFloat(item.rate)
                  )
                ),
                100
              )
            }}</span>
            <span v-else>--</span>
            {{ formData.coinType }}
          </el-col>
          <el-col :span="12" class="flex align-center">
            <span class="defi-require">单次可投范围</span>&nbsp;&nbsp;
            <el-input
              v-model="item.buyMinNum"
              class="width-100"
              placeholder="最低"
            ></el-input>
            &nbsp;&nbsp;----&nbsp;&nbsp;
            <el-input
              v-model="item.buyMaxNum"
              class="width-100"
              placeholder="最高"
            ></el-input>
            &nbsp;{{ item.defiCoinType }}
          </el-col>
          <el-col :span="12" class="flex align-center">
            <span class="defi-require">申购总限额</span> &nbsp;&nbsp;
            <el-input
              v-model="item.totalFinancing"
              class="width-200"
              placeholder="申购总限额"
              :disabled="isEdit && formData.status !== 0"
            ></el-input>
            &nbsp;{{ item.defiCoinType }}
          </el-col>
          <el-col :span="12" class="flex align-center">
            <span>用户申购限额</span> &nbsp;&nbsp;
            <el-input
              v-model="item.limitAmount"
              class="width-200"
              placeholder="用户申购限额"
            ></el-input>
            &nbsp;{{ item.defiCoinType }}
          </el-col>
        </el-row>
        <br />
        <br />

        <el-row>
          <el-col :span="12">
            <el-form-item label="锁仓期限" prop="day" required>
              <el-input
                v-model="formData.day"
                type="number"
                class="width-200"
              ></el-input>
              天
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品开始时间" prop="startTime" required>
              <el-date-picker
                v-model="formData.startTime"
                type="datetime"
                placeholder="选择日期时间"
                :disabled="isEdit && formData.status !== 0"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="购买范围" prop="scope" required>
              <el-select
                class="width-200"
                v-model="formData.scope"
                placeholder="请选择购买范围"
              >
                <el-option label="全部" :value="1"> </el-option>
                <el-option label="理财新用户" :value="2"> </el-option>
                <el-option label="平台新用户" :value="3"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="formData.scope === 3" :span="12">
            <el-form-item label="注册时间" prop="registerTime" required>
              <el-date-picker
                v-model="formData.registerTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="默认价格" prop="defaultPrice" required>
              <el-input
                v-model="formData.defaultPrice"
                type="number"
                class="width-200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLanguages } from '@/utils/encrypt.js'
import { Deficoin } from '../utill/instance.js'
import Upload from 'components/upload'

import {
  thousandSeparator,
  dateFormat,
  numMul,
  numDiv,
} from '@/utils/encrypt.js'
export default {
  inheritAttrs: false,
  components: { Upload },
  props: ['visible', 'currentId', 'isEdit'],
  data() {
    return {
      formData: {
        img: 'https://cdbkoss.oss-accelerate.aliyuncs.com/common/common20220422062453759.png',
        coinType: '',
        totalIncome: '',
        scale: '',
        day: '',
        dtos: [],
        startTime: '',
        defiCoins: [],
        scope: '',
        registerTime: '',
        defaultPrice: 0,
      },
      interestTextList: {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      },
      rateRuleList: {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      },
      tagList: [
        {
          en: '',
          es: '',
          hi: '',
          hk: '',
          jp: '',
          ko: '',
          ru: '',
          zh: '',
        },
      ],
      profileConfig: {
        accept: '.jpg,.png,.ico,.gif',
      },
      rules: {
        // img: [{ required: true, message: '请选择产品图标' }],
        // coinType: [{ required: true, message: '请选择活动币种' }],
        // totalIncome: [{ required: true, message: '请输入总共发放收益' }],
        // scale: [
        //   { required: true, message: '请输入金额精度' },
        //   { validator: checkNum },
        // ],
        // day: [{ required: true, message: '请输入锁仓期限' }],
        // dtos: [{ required: true, message: '请选择质押币种' }],
        // startTime: [{ required: true, message: '请选择产品开始时间' }],
        // scope: [{ required: true, message: '请选择购买范围' }],
        // registerTime: [{ required: true, message: '请选择注册时间' }],
        // defaultPrice: [{ required: true, message: '请输入默认价格' }],
      },
    }
  },
  computed: {
    ...mapState('financial', ['currentTreasure', 'coinList']),
    title() {
      return this.currentId ? '修改' : '新增'
    },
  },
  watch: {},
  created() {},
  mounted() {
    // this.tagList = getLanguages()
    // this.interestTextList = getLanguages()
    // this.rateRuleList = getLanguages()
  },
  methods: {
    ...{ thousandSeparator, dateFormat, numDiv, numMul },

    ...mapActions('financial', [
      'saveCurrentTreasure',
      'stakingSubmit',
      'getStakingDetail',
      'setUpload',
    ]),

    async open() {
      if (this.currentId) {
        const { code, data, msg } = await this.getStakingDetail({
          id: this.currentId,
        })
        if (code === 0) {
          this.interestTextList = data.interestText
          this.rateRuleList = data.rateRule
          this.tagList = data.tagList
          this.formData = data
          this.formData.defiCoins = data.dtos
          this.formData.dtos =
            this.formData.defiCoins.map((item) => item.defiCoinType) || []
        } else {
          this.$message({
            type: 'error',
            message: msg,
          })
        }
      }
    },
    close() {
      this.$refs['formData'].resetFields()
      this.reset()
      this.$emit('update:visible', false)
    },
    handleFormChange() {
      console.log('---')
    },
    //重置
    reset() {
      this.interestTextList = {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      }
      this.rateRuleList = {
        en: '',
        es: '',
        hi: '',
        hk: '',
        jp: '',
        ko: '',
        ru: '',
        zh: '',
      }
      this.tagList = [
        {
          en: '',
          es: '',
          hi: '',
          hk: '',
          jp: '',
          ko: '',
          ru: '',
          zh: '',
        },
      ]
    },
    defiCoinChange(coins) {
      const defiCoinsTemp = []
      coins.forEach((coin) => {
        const curCoin =
          this.formData.defiCoins.find((o) => o.defiCoinType === coin) ||
          new Deficoin(coin)
        defiCoinsTemp.push(curCoin)
      })
      this.formData.defiCoins = defiCoinsTemp

      this.formData.dtos =
        this.formData.defiCoins.map((item) => item.defiCoinType) || []
    },
    handelConfirm() {
      this.$refs['formData'].validate((valid) => {
        if (!valid) return
        if (this.currentId) {
          this.formData.id = this.currentId
        }
        const params = {
          ...this.formData,
          interestText: this.interestTextList,
          rateRule: this.rateRuleList,
          tagList: this.tagList,
          dtos: this.formData.defiCoins,
        }
        console.log(params, 'params')
        this.stakingSubmit(params).then((res) => {
          console.log(res, 'res')
          if (res.code !== 0) {
            this.$message({
              type: 'error',
              message: res.msg,
            })
            return
          }

          this.$emit('success')
          this.close()
        })
      })
    },
    imgBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2
      if (!isRightSize) {
        this.$message.error('文件大小超过 2MB')
      }
      return isRightSize
    },
    uploadIcon(e) {
      const { file } = e
      const params = new FormData()
      params.append('file', file)
      console.log(file, '---')
      this.setUpload(params).then((res) => {
        console.log(res, '---')
      })
    },
  },
}
</script>
<style lang="less" scoped>
.el-upload__tip {
  line-height: 1.2;
}
.defi-require::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
.width-200 {
  width: 200px !important;
}
.width-100 {
  width: 100px !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409eff;
    }
  }

  .el-loading-spinner {
    top: 0;
    margin-top: 0;
  }
  .flex {
    display: flex !important;
  }
  .align-center {
    align-items: center !important;
  }
  .row-center {
    justify-content: center !important;
  }
}
</style>
